import {Button, Table, Form, FormControl, InputGroup, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose, faFile, faPlus, faSave, faTrash, faWrench} from "@fortawesome/free-solid-svg-icons";
import {v4 as uuidv4} from "uuid";
import React, {useEffect, useState} from "react";
import {useAuth} from "../../../providers/authprovider";
import useAlert from "../../../components/CustomAlert";

const createEmptyDevice = function(){
    return {
        symbol:"",
        description:"",
        sn:"",
        company:"",
        city:"",
        calibration:"",
        next_calibration:"",
        inner_calibration:"",
        remarks:""
    }


}

export default function Devices(props){

    const {devices: {get, downloadDeviceFile}, viewFile} = useAuth();


    const [devices, setDevices] = useState(undefined);
    const [device, setAddEditDevice] = useState(undefined)


    useEffect(()=>{
        if(devices === undefined)
             get(({success, error, content})=>{

                 if(success)
                     return setDevices(prev=>{
                         return content;
                     });

                 alert(error)
             })
    })

    const handleAddDevice = ()=>{
        setAddEditDevice(createEmptyDevice())
    }

    const handleOpenAddEditModal = (device)=>{
        setAddEditDevice(device);
    }

    const handleHideModal = (device, removed)=>{



        if(!device) return setAddEditDevice(undefined)

        setDevices((prev)=>{

            const index = prev.findIndex(d=>d.id === device.id);

            if(removed){
                prev.splice(index, 1);
                return [...prev];
            }

            if(index > -1)
                prev.splice(index, 1, device)
            else
                prev.push(device)

            return [...prev]
        })

        setAddEditDevice(undefined)

    }

    const handleOpenFile = (deviceId)=>{

        downloadDeviceFile(deviceId, ({success, error, content})=>{

            if(success)
                return viewFile(content.file, content.type)


        })
    }

    return (
        <div className={"ps-4 pe-4 pb-4"}>
            <Button className={"m-1"} variant={"outline-info"} onClick={handleAddDevice}><FontAwesomeIcon icon={faPlus} /> Dodaj urządzenie</Button>
            <Table striped bordered hover size={"sm"}>
                <thead>
                    <tr>
                        <th>L.p.</th>
                        <th>Symbol</th>
                        <th>Opis</th>
                        <th>Numer seryjny</th>
                        <th>Firma</th>
                        <th>Kogo</th>
                        <th>Kalibracja</th>
                        <th>Następna kalibracja</th>
                        <th>Wzorcowanie</th>
                        <th>Uwagi</th>
                        <th>Plik</th>
                        <th>Edycja</th>
                    </tr>
                </thead>
                <tbody>
                {
                    devices && devices.map((device, index)=>{

                        return <tr key={device.id}>
                            <td>{index+1}</td>
                            <td>{device.symbol}</td>
                            <td>{device.description}</td>
                            <td>{device.sn}</td>
                            <td>{device.company}</td>
                            <td>{device.city}</td>
                            <td>{device.calibration}</td>
                            <td>{device.next_calibration}</td>
                            <td>{device.inner_calibration}</td>
                            <td>{device.remarks}</td>
                            <td>
                                {device.FILE && <Button variant={"outline-success"} onClick={()=>{handleOpenFile(device.id)}}><FontAwesomeIcon icon={faFile} /></Button> }

                            </td>
                            <td><Button variant={"outline-warning"} onClick={()=>{handleOpenAddEditModal(device)}} ><FontAwesomeIcon icon={faWrench} /></Button></td>
                        </tr>
                    })
                }

                </tbody>

            </Table>

            {
                device && <AddEditDeviceModal onHide={handleHideModal} device={device} show={true} />
            }

        </div>
    )
}

function AddEditDeviceModal(props){

    const {devices: {add, remove}} = useAuth();

    const [device, setDevice] = useState(()=>{

        const clonedDevice = {...props.device};
        delete clonedDevice.FILE

        if(clonedDevice.id) {
            return clonedDevice;
        }

        return {
            ...clonedDevice,
            id: uuidv4()
        }
    })
    const handleChange = e => setDevice({ ...device, [e.target.name]: e.target.value });

    const {alert, showAlert, hideAlert}= useAlert()

    const [validated, setValidate] = useState(false);

    const handleSubmit = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        hideAlert();

        const form = event.currentTarget;

        if (form.checkValidity() === true) {

            const data = new FormData()

            Object.keys(device).forEach(key=>{
                    data.append(key, device[key])
            })

            if(form.signature.files.length > 0){
                data.append('file', form.signature.files[0]);
            }



            add(data, ({success, error, content})=>{
                if(!success)
                    return showAlert(error)

                props.onHide(content)
            })

        }

        setValidate(true)
    }

    const handleDelete = ()=>{

        hideAlert();

        remove(device.id, ({success, error, content})=>{
            if(success)
                return props.onHide(content, true);

            return showAlert(error)
        })
    }



    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Form action={"post"} onSubmit={handleSubmit}  noValidate validated={validated} >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edycja urządzenia
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {alert()}
                    <InputGroup className="mb-3">
                        <InputGroup.Text className={"w-25"} id="symbol">Symbol</InputGroup.Text>
                        <FormControl
                            required
                            name={"symbol"}
                            value={device.symbol}
                            placeholder="symbol urządzenia"
                            onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            Symbol urządzenia jest wymagany
                        </Form.Control.Feedback>
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="description">Opis</InputGroup.Text>
                        <FormControl
                            name={"description"}
                            value={device.description}
                            placeholder="Opis"
                            onChange={handleChange}
                            minLength={4}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="sn">Numer seryjny</InputGroup.Text>
                        <FormControl
                            name={"sn"}
                            value={device.sn}
                            placeholder="numer seryjny"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Firma</InputGroup.Text>
                        <FormControl
                            name={"company"}
                            value={device.company}
                            placeholder="firma"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Kogo</InputGroup.Text>
                        <FormControl
                            name={"city"}
                            value={device.city}
                            placeholder="miejsce składowania"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Kilbracja</InputGroup.Text>
                        <FormControl
                            type={"date"}
                            name={"calibration"}
                            value={device.calibration}
                            placeholder="kalibracja"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Następna kalibracja</InputGroup.Text>
                        <FormControl
                            type={"date"}
                            name={"next_calibration"}
                            value={device.next_calibration}
                            placeholder="data nasepnej kalibracji"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Wzorcowanie</InputGroup.Text>
                        <FormControl
                            name={"inner_calibration"}
                            value={device.inner_calibration}
                            placeholder="wzorcowanie"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup.Text  className={"w-25"} id="company">Uwagi</InputGroup.Text>
                        <FormControl
                            as={"textarea"}
                            name={"remarks"}
                            value={device.remarks}
                            placeholder="uwagi do urządzenia"
                            onChange={handleChange}
                        />
                    </InputGroup>
                    <Form.Group className="mb-3" controlId="device_signature">
                        <Form.Label>Certyfikat</Form.Label>
                        <FormControl
                            type={"file"}
                            accept={"image/jpeg,image/gif,image/png,application/pdf"}
                            name={"signature"}
                            placeholder={"certyfikat/wzorcowanie urządzenia"}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer className={"d-flex justify-content-between"}>
                    <Button type={"button"} variant={"outline-dark"} onClick={()=>{props.onHide()}}><FontAwesomeIcon icon={faClose} /> Anuluj</Button>
                    <Button type={"button"} variant={"outline-danger"} onClick={handleDelete}><FontAwesomeIcon icon={faTrash} /> Usuń</Button>
                    <Button type={"submit"}><FontAwesomeIcon icon={faSave} /> Zapisz</Button>
                </Modal.Footer>
            </Form>



        </Modal>
    )
}